import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer";
import ResumeLayout from "./components/Resume/ResumeLayout";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import AnimatedCursor from "react-animated-cursor";
import "./style.css";
import "./App.css";
import "./style/ResumeStyles.css";
import "./style/ContactStyles.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, updateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
      <AnimatedCursor
          innerSize={15}
          outerSize={15}
          color="59, 130, 246"
          outerStyle={{ backgroundColor: "rgba(128, 128, 128, 0.5)" }}
          outerAlpha={0.1}
          innerScale={1.2}
          outerScale={1.5}
          clickables={[
            "a",
            "input[type='text']",
            "input[type='email']",
            "input[type='number']",
            "input[type='submit']",
            "input[type='image']",
            "label[for]",
            "textarea",
            "button",
            ".link"
          ]}
        />
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resume" element={<ResumeLayout />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;